import {useEffect} from "react"
import {AllData, apiItems, apiItemsLoading} from "./alldata"
import {AllDataState} from "./LoggedinMainPage"
import {ItemLoadProgress} from "./ItemLoadProgress"
import {useNavigate} from "react-router-dom";
import {useDivision} from "./shared"
import "./LoadAllDataPage.scss"

type Props = {
  allData: AllData
  allDataState: AllDataState
  setAllDataState: (ads: AllDataState) => void
}

export function LoadAllDataPage({allData, allDataState, setAllDataState}: Props) {
  useEffect(() => {
    if (allDataState === "errorsNotDismissed" && allData.done
        && allData.errors.length === 0 && allData.warnings.length === 0) {
          setAllDataState("done")
    }
  }, [setAllDataState, allDataState, allData])
  const navigate = useNavigate()
  const division = useDivision()
  const allDataKeys = (
    allData.done ? Object.keys(apiItems) : Object.keys(apiItemsLoading)
  ) as ReadonlyArray<keyof typeof apiItems & keyof typeof allData> 
  const loaddata = <>
    {allDataKeys.map(k => {
        const loadedItems = allData.done ?
          allData[k] : allData[k].loadedItems
        const done = allData.done || allData[k].done
        const error = allData.done ? null : allData[k].loadError
        const name = k[0].toUpperCase() + k.slice(1)
        return <ItemLoadProgress key={name} error={error} isLoading={!done}
          items={loadedItems} itemsName={name} />
      })
    }
    <div id="loadataprogressmessage">
      {allData.done ? <>Done loading all data</>
      : allDataKeys.some(k => allData[k].loadError) ? <>
        There was an error while loading the data. Please report this as soon as
        possible, add the following details:
        <ul>
          {allDataKeys
            .filter(k => allData[k].loadError)
            .map(k => <li key={k}>
              {k[0].toUpperCase() + k.slice(1)}: {allData[k].loadError}
            </li>)
          }
        </ul>
      </> : <>
      Currently loading all data.
      This may take a small while (30 seconds or so, longer during busy times on
        Exact; usually between 8:30 and 11:30);
      If you don't see any progress for more than a minute, reload this page;
        this should almost never be necessary.
      </>
      }
    </div>
  </>
  if (allData.done === false) {
    return loaddata
  }

  return <>{loaddata}
    {allDataState === "errorsNotDismissed" &&
      <div className="allDataErrors">
        <h3>
          There are {allData.errors.length} errors
          and {allData.warnings.length} warnings
        </h3>
        <button data-cy="errors-warning-review"
          onClick={() => {
            setAllDataState("done")
            navigate(`/division/${division}/`)
          }}>review</button>
        <button data-cy="errors-warning-dismiss"
          onClick={() => setAllDataState("done")}>dismiss</button>
      </div>
    }
  </>
}
